var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title"},[_c('h1',{staticClass:"section-title-title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('span',{staticClass:"section-title-description"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }